import commonHelper from '@/app/utility/common.helper.utility';
import { required } from 'vuelidate/lib/validators';
export default {
  name: 'expiryAlert',
  components: {
  },
  watch: {
    currentPage: function () {
      this.getStatusData();
    },
    perPage: function () {
      this.currentPage = 1;
      this.getStatusData();
    }
  },
  data() {
    return {
      parent_value_set_id: null,
      showValueSetModal: false,
      payload: null,
      unsubscribe: null,
      currentPage: 1,
      totalRows: null,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      loader: false,
      vsetCode: null,
      setTimeVsetCode: null,
      docNo: null,     
      expiryData: [],
      weighMachineFields: [
        {
          key: 'serail_no',
          label: 'S.No.'
        },
        {
          key: 'doc_num',
          label: 'Document No.'
        },
        {
          key: 'le_name',
          label: 'Legal Entity'
        },
        {
          key: 'po_number'
        },
        {
          key: 'org_name',
          label: 'Cost Center'
        },
        {
          key: 'description'
        },
        {
          key: 'oracle_id'
        },
        {
          key: 'book_type_code',
          label: 'Book Type'
        },
        {
          key: 'actual_cost'
        },
        {
          key: 'hsn_sac_code',
          label: 'HSN / SAC Code'
        },
        {
          key: 'asset_status'
        },
        {
          key: 'model_number',
          label: 'Model No.'
        },
        {
          key: 'installation_date'
        },
        {
          key: 'accuracy_resolution'
        },
        {
          key: 'department_user_responsible"',
          label: 'Department'
        },
        {
          key: 'capacity_unit'
        },
        {
          key: 'exp_date',
          label: 'Expiry Date'
        },
        {
          key: 'calib_date',
          label: 'Calibration Date'
        },
      ],
      rowData: null
    };
  },
  validations: {
    docNo: {required}
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'add') {
          // this.showHideAdditionalModal(true);
        }
      }
    });
  },
  methods: {
    getStatusData() {  
      this.$v.$touch();
      if (!this.$v.$invalid) {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        doc_num: this.docNo,
      };
      this.loader = true;
      this.$store
        .dispatch('weighMachine/getStatusData', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            this.expiryData = resp.data.data;
            this.totalRows = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    }
    },
    clear() {
      this.docNo = null
      this.totalRows = null;
      this.expiryData = [];
    }
  },
  beforeDestroy() {
    clearTimeout(this.setTimeVsetCode);
    this.unsubscribe();
  }
};
